import { useEffect } from 'react';
import { Beer } from 'lucide-react';
import Card from './Cards';
import { useTranslation } from 'react-i18next';

export default function Home() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('common.appName');
  }, [t]);

  return (
    <div>
      <Card title={t('home.title')}>
        <p className="text-muted-foreground mb-4">
          {t('home.description')}<br />
          {t('home.tagline')}
        </p>
        <div className="flex items-center justify-center gap-2 text-primary text-4xl py-2">
          <Beer className="h-10 w-10 rotate-12" />
          <Beer className="h-10 w-10 -rotate-12" />
        </div>
      </Card>
    </div>
  );
}
